import {Observable} from 'rxjs';

import Media          from '../../../State/Stores/Media/Media';
import PlaybackStatus from '../../../State/Stores/Playback/Constants/PlaybackStatus';
import ISolution      from '../Interfaces/ISolution';

const subscribeToPlaybackStatusWithMedia = (
    playbackStatusWithMedia$: Observable<[PlaybackStatus, Media]>,
    solution: ISolution
) =>
    playbackStatusWithMedia$
        .subscribe(([nextPlaybackStatus, latestMedia]) => {
            switch (nextPlaybackStatus) {
                case PlaybackStatus.A_LOADING:
                case PlaybackStatus.B_LOADING: {
                    solution.load(latestMedia);

                    break;
                }
                case PlaybackStatus.UNLOADED:
                case PlaybackStatus.ERRORED:
                    solution.unload();

                    break;
                case PlaybackStatus.PLAYING:
                    solution.play();

                    break;
                case PlaybackStatus.PAUSED:
                    solution.pause();

                    break;
            }
        });

export default subscribeToPlaybackStatusWithMedia;